export default __webpack_public_path__ + "static/media/social-instagram-blue.a4ed95ae.svg";